module.exports = __webpack_public_path__ + "img/chp-coloured-white-txt.a65e3fc3.svg";